(function ($) {
	/* ---------------------------------------
		メイン　スライド
	--------------------------------------- */
	$('.top_main_slide').slick({
		arrows: false,
		autoplay: true,
		autoplaySpeed: 5000,
		infinite: true,
		speed: 1500,
		fade: true,
		dots: true
	});

	/* ---------------------------------------
		コーディネート　スライド
	--------------------------------------- */
	const $slider = $(".top_coordination_slide");
	// 左右の透過の2周目ががたつく対応
	$slider.on("beforeChange", (event, slick, currentSlide, nextSlide) => {
		$slider.find(".slick-slide").each((index, el) => {
			const $this = $(el),
				slickindex = $this.attr("data-slick-index");
			if (nextSlide == slick.slideCount - 1 && currentSlide == 0) {
				// 現在のスライドが最初のスライドでそこから最後のスライドに戻る場合
				if (slickindex == "-1") {
					// 最後のスライドに対してクラスを付与
					$this.addClass("is-active-next");
				} else {
					// それ以外は削除
					$this.removeClass("is-active-next");
				}
			} else if (nextSlide == 0) {
				// 次のスライドが最初のスライドの場合
				if (slickindex == slick.slideCount) {
					// 最初のスライドに対してクラスを付与
					$this.addClass("is-active-next");
				} else {
					// それ以外は削除
					$this.removeClass("is-active-next");
				}
			} else {
				// それ以外は削除
				$this.removeClass("is-active-next");
			}
		});
	});
	$slider.slick({
		infinite: true,
		speed: 1000,
		slidesToShow: 1,
		centerMode: true,
		variableWidth: true,
		appendArrows: $('.slick_arrows'),
		prevArrow: '<div class="slick_prev"></div>',
		nextArrow: '<div class="slick_next"></div>',
	});
	/* ---------------------------------------
	end
	--------------------------------------- */
})(jQuery);